import { render, staticRenderFns } from "./OrgReviewsInPeriod.vue?vue&type=template&id=6ff5df86&scoped=true&"
import script from "./OrgReviewsInPeriod.vue?vue&type=script&lang=js&"
export * from "./OrgReviewsInPeriod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff5df86",
  null
  
)

export default component.exports